import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { Step, StepBase, StepSearch } from '../../models/engineering/step';

@Injectable({
  providedIn: 'root',
})
export class StepProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/steps';

  public getStepById(stepId: string): Observable<ApiResponse<Step>> {
    return this.httpClient.get<ApiResponse<Step>>(`${this.baseUrl}/${stepId}`);
  }

  public upsertStep(step: Step): Observable<ApiResponse<Step>> {
    return this.httpClient.post<ApiResponse<Step>>(`${this.baseUrl}`, step);
  }

  public insertStep(step: StepBase): Observable<ApiResponse<Step>> {
    return this.httpClient.post<ApiResponse<Step>>(`${this.baseUrl}`, step);
  }

  public updateStep(step: Step): Observable<ApiResponse<Step>> {
    return this.httpClient.put<ApiResponse<Step>>(`${this.baseUrl}/${step.stepId}`, step);
  }

  public searchSteps(stepSearch: StepSearch): Observable<ApiResponse<Step[]>> {
    return this.httpClient.post<ApiResponse<Step[]>>(`${this.baseUrl}/search`, stepSearch);
  }
}
